import i18n from "@/i18n";

/* eslint-disable quotes */
export default {
  totalHistoricValue: 345_334_275,
  activities: [
    {
      id: 'projects',
      title: {
        it: 'Progetti',
        en: 'Projects'
      },
      cover: {
        desktop: '/images/value/projects/cover-projects.jpg',
        mobile: '/images/value/projects/cover-projects.jpg'
      },
      value: 1_291_190,
      color: '#F8D238',
      items: [
        {
          id: 0,
          value: 302_332.0,
          year: 2021,
          image: '/images/value/projects/parallel-education.jpg',
          title: {
            it: 'Parallel Education',
            en: 'Parallel Education'
          },
          palette: {
            background: '#3EC7E0',
            foreground: '#7C4EBB'
          },
          links: [
            {
              lang: 'it',
              url: 'https://www.fondazioneagnelli.it/progetti/parallel-education/'
            },
            {
              lang: 'en',
              url: 'https://www.fondazioneagnelli.it/en/progetti/parallel-education-2/'
            },
            { name: 'www.paralleleducation.it', url: 'https://www.paralleleducation.it/' }
          ],
          description: {
            it:
              'Uno strumento digitale per la crescita professionale dei docenti. Condivisione dei metodi didattici e confronto peer-to-peer per fare emergere l’innovazione diffusa nelle scuole.',
            en:
              'A digital tool for teachers’ professional growth. Shared teaching methods and peer-to-peer dialogue to foster crowdsourced innovation in schools.'
          }
        },
        {
          id: 1,
          value: 269_175.0,
          year: 2021,
          image: '/images/value/projects/sei.jpg',
          title: {
            it: 'SEI',
            en: 'SEI'
          },
          links: [
            {
              lang: 'it',
              url: 'https://www.fondazioneagnelli.it/progetti/school-of-entrepreneurship/',
            },
            {
              lang: 'en',
              url: `https://www.fondazioneagnelli.it/en/progetti/school-of-entrepreneurship-and-innovation/`,
            },
            {
              url: 'https://sei.it/',
              name: 'www.sei.it'
            }
          ],
          palette: {
            background: '#F8D238',
            foreground: '#18C8B5'
          },
          description: {
            it:
              'Percorsi di formazione per sviluppare le capacità imprenditoriali degli studenti universitari. Realizzati da Collège des Ingénieurs Italia con importanti partner torinesi.',
            en:
              'Training courses for university students wanting to develop their entrepreneurial skills. Carried out by Collège des Ingénieurs Italia, with major local partners.'
          }
        },
        {
          id: 2,
          value: 119_748.0,
          year: 2021,
          image: '/images/value/projects/combo.jpg',
          title: {
            it: 'Combo',
            en: 'Combo'
          },
          palette: {
            background: '#38B5CD',
            foreground: '#F8D238'
          },
          links: [
            {
              lang: 'it',
              url: 'https://www.fondazioneagnelli.it/progetti/combo/',
            },
            {
              lang: 'en',
              url: `https://www.fondazioneagnelli.it/en/progetti/combo-en/`
            },
            {
              url: 'https://combo.fondazioneagnelli.it/',
              name: 'www.combo.fondazioneagnelli.it'
            }
          ],
          description: {
            it:
              'Workshop di didattica innovativa in materie STEM per le scuole di Torino e Piemonte, con robot educativi. Dopo la pandemia si è rinnovato con RoboSpazio, un workshop digitale fruibile da remoto.',
            en:
              'STEM workshops with innovative methods, for schools in Turin and Piedmont, with robots. After Covid pandemic the workshop has become an online experience.'
          }
        },
        {
          id: 3,
          value: 104_871.0,
          year: 2021,
          image: '/images/value/projects/formazione-e-responsabilita-sociale.jpg',
          title: {
            it: `Formazione e responsabilità sociale d'impresa`,
            en: `Training and Corporate Social Responsability`
          },
          palette: {
            background: '#CB5263',
            foreground: '#F8D238'
          },
          links: [
            {
              lang: 'it',
              url: `https://www.fondazioneagnelli.it/progetti/formazione-e-responsabilita-sociale-dimpresa/`,
            },
            {
              lang: 'en',
              url: `https://www.fondazioneagnelli.it/en/progetti/training-and-corporate-social-responsability/`,
            },
          ],
          description: {
            it:
              `Attività di formazione alla realizzazione di progetti educativi in ambito di responsabilità sociale d'impresa e investimenti ESG.`,
            en:
              `Training activities on the implementation of educational projects in the field of corporate social responsibility and ESG investments.`
          }
        },
        {
          id: 4,
          value: 100_578.0,
          year: 2021,
          image: '/images/value/projects/borse-di-studio.jpg',
          title: {
            it: 'Borse di studio',
            en: 'Scholarships'
          },
          links: [
            {
              lang: 'it',
              url: 'https://www.fondazioneagnelli.it/progetti/borse-di-studio-e-prestiti-donore/'
            },
            {
              lang: 'en',
              url: 'https://www.fondazioneagnelli.it/en/progetti/scholarships/',
            }
          ],
          palette: {
            background: '#18C8B5',
            foreground: '#E95263'
          },
          description: {
            it:
              'Borse ed erogazioni per sostenere e valorizzare il percorso di studenti meritevoli.',
            en:
              `Scholarships and financial aid to support and enhance deserving students' education.`
          }
        },
        {
          id: 5,
          value: 82_121.0,
          year: 2021,
          image: '/images/value/projects/livemotiv.jpg',
          title: {
            it: 'Livemotiv',
            en: 'Livemotiv'
          },
          palette: {
            background: '#7244B1',
            foreground: '#F8D238'
          },
          links: [
            {
              lang: 'it',
              url: `https://www.fondazioneagnelli.it/progetti/livemotiv/`
            },
            {
              lang: 'en',
              url: 'https://www.fondazioneagnelli.it/en/progetti/livemotiv-2/',
            }
          ],
          description: {
            it: `Un progetto di educazione all'ascolto musicale, con De Sono Associazione per la musica, per le scuole secondarie di II grado in Italia. Workshop dal vivo, nella forma di lezioni-concerto con la presenza di giovani strumentisti.`,
            en: `A music listening education project aimed at secondary schools throughout Italy. Live workshop, in the form of lessons-concert with the presence of young players. In partnership with De Sono Associazione per la musica.`
          },
        },
        {
          id: 6,
          value: 47_697.0,
          year: 2021,
          image: '/images/value/projects/hop.png',
          title: {
            it: 'HOP - Hands On Physics',
            en: 'HOP - Hands On Physics'
          },
          palette: {
            background: '#16B8A6',
            foreground: '#7C4EBB'
          },
          description: {
            it:
              `Progetto in progress di innovazione didattica e formazione dei docenti per l'insegnamento di materie STEM nelle scuole medie italiane. Con CERN nell'ambito del progetto CERN Science Gateway.`,
            en:
              `Project in progress of didactic innovation and teacher training for the teaching of STEM subjects in Italian junior secondary school, with CERN as part of the CERN Science Gateway project.`
          }
        },
        {
          id: 7,
          value: 36_465.0,
          year: 2021,
          image: '/images/value/projects/ripit.jpg',
          title: {
            it: 'Ripit',
            en: 'Ripit'
          },
          palette: {
            background: '#7C4EBB',
            foreground: '#18c8b5'
          },
          links: [{ url: ' https://www.ripit.it/', name: 'www.ripit.it' }],
          description: {
            it:
              `Una risorsa digitale flessibile, intuitiva e gratuita per migliorare la pronuncia inglese in modo interattivo. Per gli studenti e i loro insegnanti, in collaborazione con Sana Labs.`,
            en:
              `A flexible, user-friendly and free digital resource to improve English pronunciation interactively. Designed for Italian students and their teachers, in collaboration with Sana Labs.`
          }
        },
        {
          id: 8,
          value: 16_105.0,
          year: 2021,
          image: '/images/value/projects/torino-fa-scuola.jpg',
          title: {
            it: 'Torino fa Scuola',
            en: 'Torino fa Scuola'
          },
          links: [
            {
              lang: 'it',
              url: 'https://www.fondazioneagnelli.it/progetti/torino-fa-scuola/'
            },
            {
              lang: 'en',
              url: `https://www.fondazioneagnelli.it/en/progetti/torino-fa-scuola-en/`,
            },
            {
              url: 'https://www.torinofascuola.it/',
              name: 'www.torinofascuola.it'
            }
          ],
          palette: {
            background: '#EDBC4D',
            foreground: '#E95263'
          },
          description: {
            it:
              'Monitoraggio dell’innovazione didattica e ulteriori perfezionamenti alla riqualificazione del 2019 di 2 scuole medie, con nuovi ambienti di apprendimento. Con Compagnia di San Paolo e Città di Torino.',
            en:
              'Monitoring of learning innovation and further fine-tuning of the 2019 redevelopment of 2 junior secondary schools. With Compagnia di San Paolo and Città di Torino.'
          }
        },
        {
          id: 9,
          value: 212_098.0,
          year: 2021,
          image: '/images/value/projects/altri-progetti.jpg',
          title: {
            it: 'Altri progetti',
            en: 'Other projects'
          },
          description: {
            it:
              'Scuola in Ospedale, Alleanza Italiana per lo Sviluppo Sostenibile (ASviS), Teach for Italy, Intercultura.',
            en:
              'Scuola in Ospedale, Alleanza Italiana per lo Sviluppo Sostenibile (ASviS), Teach for Italy, Intercultura.'
          },
          palette: {
            background: '#E95263',
            foreground: '#18C8B5'
          }
        }
      ]
    },
    {
      title: {
        it: 'Ricerca',
        en: 'Research'
      },
      id: 'research',
      cover: {
        desktop: '/images/value/research/cover-research.jpg',
        mobile: '/images/value/research/cover-research.jpg'
      },

      value: 909_925.0,
      color: '#7C4EBB',
      items: [
        {
          id: 10,
          value: 377_072,
          year: 2021,
          image: '/images/value/research/analisi-politiche.jpg',
          title: {
            it: 'Analisi politiche scolastiche',
            en: 'School policy analysis'
          },
          palette: {
            background: '#E95263',
            foreground: '#18C8B5'
          },
          description: {
            it:
              'Studi, fact-checking e riflessioni critiche sulle politiche scolastiche e le riforme del sistema d’istruzione avviate dai diversi governi in Italia e sulla loro reale efficacia.',
            en:
              `Studies, fact-checking and critical reflections on school policies, the reforms of the education system the Italian government has implemented over time, and their actual effectiveness.`
          },
          links: [
            {
              lang: 'it',
              url: 'https://www.fondazioneagnelli.it/temi/politiche-scolastiche/'
            },
            {
              lang: 'en',
              url: `https://www.fondazioneagnelli.it/en/temi/school-policies/`
            }
          ]
        },
        {
          id: 11,
          value: 181_563.0,
          year: 2021,
          image: '/images/value/research/eduscopio.jpg',
          title: {
            it: 'Eduscopio',
            en: 'Eduscopio'
          },
          links: [
            {
              lang: 'it',
              url: 'https://www.fondazioneagnelli.it/progetti/eduscopio/'
            },
            {
              lang: 'en',
              url: `https://www.fondazioneagnelli.it/en/progetti/eduscopio-en/`,
            },
            {
              url: 'https://eduscopio.it/',
              name: 'www.eduscopio.it'
            }
          ],
          palette: {
            background: '#EDBC4D',
            foreground: '#E95263'
          },
          description: {
            it:
              `Quali scuole superiori preparano meglio per l'università e il mondo del lavoro? Il portale gratuito che aiuta gli studenti italiani e le loro famiglie a scegliere.`,
            en:
              'Which secondary schools provide the best preparation for university and the workplace? A free portal to help Italian students and their families make the right choice.'
          }
        },
        {
          id: 12,
          value: 167_690.0,
          year: 2021,
          image: '/images/value/research/scuola-media.jpg',
          title: {
            it: 'Rapporto scuola media',
            en: 'Report on Junior Secondary School'
          },
          palette: {
            background: '#18C8B5',
            foreground: '#CB5263'
          },
          links: [
            {
              url: 'https://scuolamedia.fondazioneagnelli.it/ ',
              name: `www.scuolamedia.fondazioneagnelli.it`
            }
          ],
          description: {
            it:
              `Nuovo rapporto della Fondazione per la prima volta interamente digitale, ritorna sulle criticità della scuola media, a distanza di 10 anni dalla pubblicazione originaria. Con una serie di nuove proposte di politica scolastica.`,
            en:
              `First entirely digital report of the Foundation, it investigates the current situation of the junior secondary school, 10 years after the first report. With a new series of school policy proposals.`,
          }
        },
        {
          id: 13,
          value: 103_793.0,
          year: 2021,
          image: '/images/value/research/christine-lagarde.jpg',
          title: {
            it: 'Christine Lagarde - Dialogue in a Changing World',
            en: 'Christine Lagarde - Dialogue in a Changing World'
          },
          palette: {
            background: '#F8D238',
            foreground: '#38B5CD'
          },
          links: [
            {
              lang: 'it',
              url: `https://www.fondazioneagnelli.it/2021/11/30/christine-lagarde-a-torino-dialogue-in-a-changing-world/`
            },
            {
              lang: 'en',
              url: `https://www.fondazioneagnelli.it/en/2021/11/30/christine-lagarde-in-turin-dialogue-in-a-changing-world/`
            }
          ],
          description: {
            it:
              `La Presidente della Banca Centrale Europea in una Lectio Magistralis a Torino per promuovere i valori della diplomazia e della scienza nelle relazioni internazionali. Con Collegio Carlo Alberto e Accademia Nazionale dei Lincei.`,
            en:
              `The President of the European Central Bank in a Lectio Magistralis in Turin to promote the values of diplomacy and science in international relations. With Collegio Carlo Alberto e Accademia Nazionale dei Lincei.`
          }
        },
        {
          id: 14,
          value: 35_951.0,
          year: 2021,
          image: '/images/value/research/rapporti-di-ricerca.jpg',
          title: {
            it: 'Rapporti di ricerca',
            en: 'Research reports'
          },
          palette: {
            background: '#7C4EBB',
            foreground: '#3EC7E0'
          },
          description: {
            it:
              `Attività di ricerca relativa all'edilizia scolastica.`,
            en:
              `Research activities on school buildings and learning spaces.`
          }
        },
        {
          id: 15,
          value: 43_856.0,
          year: 2021,
          image: '/images/value/research/altre-ricerche.jpg',
          title: {
            it: 'Altre ricerche',
            en: 'Other research'
          },
          palette: {
            background: '#3EC7E0',
            foreground: '#7C4EBB'
          },
          description: {
            it:
              `Ricerche documentarie, metanalisi e approfondimenti macroeconomici.`,
            en:
              `Documentary research, meta-analysis and macroeconomic insights.`,
          }
        }
      ]
    },
    {
      id: 'solidarity',
      title: {
        it: 'Solidarietà',
        en: 'Solidarity'
      },
      notes: {
        it: 'Gli Interventi a sostegno delle persone fisiche e degli enti nazionali e locali di assistenza sono gestiti dalla Fondazione La Stampa-Specchio dei Tempi.',
        en: 'Initiatives suporting private individuals, national and local welfare organizations are managed by the La Stampa-Specchio dei Tempi Foundation.'
      },
      cover: {
        desktop: '/images/value/solidarity/cover-solidarity.jpg',
        mobile: '/images/value/solidarity/cover-solidarity.jpg'
      },
      value: 647_425,
      color: '#18C8B5',
      items: [
        {
          id: 16,
          value: 312_500,
          year: 2021,
          image: '/images/value/solidarity/persone-fisiche.jpg',
          title: {
            it: 'Persone fisiche',
            en: 'Private individuals'
          },
          palette: {
            background: '#18C8B5',
            foreground: '#E95263'
          },
          description: {
            it:
              'Erogazione immediata di somme limitate per allievare specifiche situazioni critiche di persone bisognose.',
            en:
              'Instant distribution of small sums to relieve specific, critical situations for people in need.'
          }
        },
        {
          id: 17,
          value: 181_451,
          year: 2021,
          image: '/images/value/solidarity/agnelli-per-i-salesiani.jpg',
          title: {
            it: 'Fondazione Agnelli per i Salesiani',
            en: 'Agnelli Foundation for Salesians school'
          },
          palette: {
            background: '#7C4EBB',
            foreground: '#3EC7E0'
          },
          description: {
            it:
              `Ambienti di apprendimento rinnovati all'Istituto Internazionale E. Agnelli - Salesiani Don Bosco: il laboratorio di meccatronica e di elettronica ristrutturato con avanzate strumentazioni di robotica e intelligenza artificiale per gli studenti.`,
            en:
              `Completely renovated learning environments at International Institute E. Agnelli: the institute's mechatronics and electronics laboratories have been renovated, with advanced robotics and artificial intelligence equipment available to students.`
          }
        },
        {
          id: 18,
          value: 60_484,
          year: 2021,
          image: '/images/value/solidarity/enti-nazionali.jpg',
          title: {
            it: 'Enti nazionali di assistenza',
            en: 'National welfare organisations'
          },
          palette: {
            background: '#EDBC4D',
            foreground: '#E95263'
          },
          description: {
            it:
              'Erogazioni a enti del terzo settore attivi in campo sanitario e assistenziale. Area, Fond. S.Anna, Sindrome di Williams, Fond. Piemontese per la Ricerca sul Cancro, Fond. Asphi, Cucina Malati Poveri.',
            en:
              'Contributions to third sector organisations for health and welfare initiatives: Area, Fond. S.Anna, Sindrome di Williams, Fond. Piemontese per la Ricerca sul Cancro, Fond. Asphi, Cucina Malati Poveri.'
          }
        },
        {
          id: 19,
          value: 50_403,
          year: 2021,
          image: '/images/value/solidarity/enti-locali.jpg',
          title: {
            it: 'Enti locali di assistenza',
            en: 'Local welfare organisations'
          },
          palette: {
            background: '#3EC7E0',
            foreground: '#7C4EBB'
          },
          description: {
            it:
              'Contributi a enti del terzo settore a livello locale, per interventi di solidarietà in campo sanitario e assistenziale.',
            en:
              'Contributions to local-level third sector organisations, towards solidarity initiatives for health and welfare.'
          }
        },
        {
          id: 20,
          value: 42_587,
          year: 2021,
          image: '/images/value/solidarity/emergenza-covid.jpg',
          title: {
            it: `Risposta all'emergenza Covid`,
            en: `Response to Covid Emergency`
          },
          palette: {
            background: '#E95263',
            foreground: '#18C8B5'
          },
          links: [
            {
              lang: 'it',
              url: `https://www.fondazioneagnelli.it/progetti/risposte-allemergenza-covid-19/`
            },
            {
              lang: 'en',
              url: `https://www.fondazioneagnelli.it/en/progetti/response-to-the-covid-19-emergency/`
            }
          ],
          description: {
            it:
              `Interventi realizzati nel periodo dell'emergenza sanitaria, spesso collaborando con altri partner, cercando di dare aiuti concreti alle scuole e alla comunità, nazionale e locale.`,
            en:
              `Interventions carried out in the period of the health emergency, often collaborating with other partners, trying to give concrete help to schools and the community, national and local.`
          }
        }
      ]
    }
  ],
  'Valore aggiunto destinato ad attività future': 565_904.0,
  'Valore aggiunto distribuito / destinato a iniziative future': 3_320_119.0
};
